import { PlanPeriod, PlanType } from "../configs/constants";

const toInteger = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.floor(number) : null;
};

export const isDailySubscriptionPlan = (plan) => {
  if (!plan || typeof plan !== "object") return false;

  return (
    toInteger(plan.type) === PlanType.Daily &&
    toInteger(plan.period) === PlanPeriod.Daily
  );
};

export const getDailySubscriptionPlan = (plans = []) => {
  if (!Array.isArray(plans)) return null;

  return plans.find(isDailySubscriptionPlan) || null;
};

export const createDailyPlanSelection = (plan, usersCount) => {
  if (!isDailySubscriptionPlan(plan)) return null;

  const normalizedUsers = toInteger(usersCount);

  return {
    period: PlanPeriod.Daily,
    users_count: normalizedUsers && normalizedUsers > 0 ? normalizedUsers : 1,
  };
};
